import { gql } from '@apollo/client';

export const paginationNotificationQuery = gql`
  query paginationNotificationQuery($page: Int, $perPage: Int) {
    paginationNotificationQuery(page: $page, perPage: $perPage) {
      items {
        _id
        type
        title
        message
        isRead
        readAt
        createdAt
        data {
          course
          courseAlias
          courseTitle
          event
          student
          studentName
          teacher
          teacherName
          zeroLessonDateTime
          actionUrl
          actionType
        }
      }
      pageInfo {
        currentPage
        perPage
        itemCount
        pageCount
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const notificationUnreadCountQuery = gql`
  query notificationUnreadCountQuery {
    notificationUnreadCountQuery {
      count
    }
  }
`;

export const markNotificationAsReadMutation = gql`
  mutation markNotificationAsReadMutation($_id: MongoID!) {
    markNotificationAsReadMutation(_id: $_id) {
      status
      modifiedCount
    }
  }
`;

export const markNotificationsPageAsReadMutation = gql`
  mutation markNotificationsPageAsReadMutation($ids: [MongoID!]) {
    markNotificationsPageAsReadMutation(ids: $ids) {
      status
      modifiedCount
    }
  }
`;

export const markAllNotificationsAsReadMutation = gql`
  mutation markAllNotificationsAsReadMutation {
    markAllNotificationsAsReadMutation {
      status
      modifiedCount
    }
  }
`;
